import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';

const images = pageImages['open-end-automatic-tie-balers'];


const automaticTieModelHeaders = ['Series', '3030', '3430', '3442', '5030'];

const automaticTieModelRows = [
  ['Hopper/Feed Opening (LxW)', '30 X 30', '34 X 30', '34 X 42', '50 X 30'],
  ['Strokes Per Minute', '2 to 5', '2 to 6', '2 to 6', '2 to 6'],
  ['Cylinder Bore', '6, 7, 8 or 10', '6, 7, 8 or 10', '6, 7, 8 or 10', '6, 7, 8 or 10'],
  ['Power Unit HP', '20 to 50', '30 to 50', '30 to 50', '30 to 50'],
];

function OpenEndAutomaticTieBalers() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link to="/closed-end-manual-tie-balers">Closed-End Manual Tie Balers</Link>
          <Link className="active" to="/open-end-automatic-tie-balers">Open-End Automatic Tie Balers</Link>
          <Link to="/wide-mouth-open-end-automatic-tie-balers">Wide-Mouth Open-End Automatic Tie Balers</Link>
          <Link to="/multi-materials-full-eject-closed-end-balers">Multi Materials Full-Eject Closed-End Balers</Link>
          <Link to="/open-end-manual-tie-balers">Open-End Manual Tie Balers</Link>
          <Link to="/cart-lifters-dumpers-dump-carts">Cart Lifters, Dumpers &amp; Dump Carts</Link>
          <Link to="/conveyors-bale-conveying-bagging-systems">Conveyors, Bale Conveying &amp; Bagging Systems</Link>
          <Link to="/used-clothing-balers">Used Clothing Balers</Link>
          <Link to="/cotton-gin-textile-baling-presses">Cotton Gin &amp; Textile Baling Presses</Link>
          <Link to="/biomass-cotton-gin-trash-baling-press">Biomass &amp; Cotton Gin Trash Baling Press</Link>
          <Link to="/vertical-down-packing-baling-presses-balers">Vertical &amp; Down-Packing Baling Presses &amp; Balers</Link>
          <Link to="/custom-designed-specialty-balers">Custom Designed &amp; Specialty Balers</Link>
          <Link to="/precrush-compactors-waste-compactors">PreCrush Compactors &amp; Waste Compactors</Link>
        </aside>
        <article className="article">
          <span className="eyebrow">Products</span>
          <h2>Open-End Automatic Tie Balers</h2>
          <div className="body-copy page-summary-copy"><strong>Automatic tying horizontal open-end balers</strong> for medium and high production baling of paper, paper trim, trimmed or shredded corrugated, box board trim, small cartons, non-wovens, fiberglass, aluminum beverage containers, and other <strong>industrial trimmings</strong>.</div>
          <div className="page-summary-notes">
              <span>Dependable wire inserting and tying mechanism</span>
              <span>Independent electric and hydraulic systems</span>
              <span>Simple adjustments and servicing</span>
          </div>
          <PagePhotoViewer images={images} eyebrow="Equipment Photos" />
          <div className="content-stack">
            
            <section className="content-block">
              <h3>Standard Single Ram Automatic Tie Models</h3>
              <div className="body-copy">The original automatic tie model table outlines the common <strong>feed openings</strong>, cycle range, cylinder bore choices, and <strong>hydraulic power packages</strong> used for standard C+M automatic tie balers.</div>
              <div className="spec-table-block">
                <table className="spec-table">
                  <thead>
                    <tr>{automaticTieModelHeaders.map((header) => <th key={header}>{header}</th>)}</tr>
                  </thead>
                  <tbody>
                    {automaticTieModelRows.map((row) => (
                      <tr key={row[0]}>{row.map((cell, cellIndex) => <td key={`${row[0]}-${cellIndex}`}>{cell}</td>)}</tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default OpenEndAutomaticTieBalers;
